import React, { useEffect, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { EMPTY_STRING, ModalContext } from 'commons-ui';

import { GAME_NAME_LABLES } from 'pages/constants';
import useGameplay from '../useGameplay';
import { SelectFilterContent } from '../selectFilter';
import { GAME_NAME } from '../constants';

const useFilter = () => {
	const { getGameplayData, handleFilterSubmit, forceUpdate, showLoader } = useGameplay();
	const [changeFilter, setChangeFilter] = useState(false);

	const { setModalConfig } = useContext(ModalContext);
	const location = useLocation();

	const handleFilterFormClose = () => {
		setModalConfig({ isOpen: false });
		setChangeFilter(false);
	};

	const handleFilterModalOpen = () => {
		setModalConfig({
			isOpen: true,
			header: 'Enter Tournaments Filter',
			content: <SelectFilterContent handleFilterSubmit={handleFilterSubmit} onClose={handleFilterFormClose} />
		});
	};

	useEffect(() => {
		if (changeFilter) {
			handleFilterModalOpen();
		}
	}, [changeFilter]);

	useEffect(() => {
		handleFilterModalOpen();
	}, []);

	const getGameName = () => {
		const querySearchParams = new URLSearchParams(location.search);
		return _get(GAME_NAME_LABLES, querySearchParams.get(GAME_NAME) || EMPTY_STRING);
	};

	return {
		getGameplayData,
		forceUpdate,
		showLoader,
		setChangeFilter,
		getGameName
	};
};

export default useFilter;
